module.exports = __webpack_public_path__ + "img/brew1.913a858b.png";